import "../component/Navbar.js";
import "../component/Header.js";

import "../component/fixConsoleLog.js";
import "../component/checkAuth.js";
import "../component/displayBalance.js";
import { showAlert, safeFetch } from "../component/functionFromExport.js";

import { Zuck } from './zuck.js'

import './zuck.js/dist/zuck.css';
import './zuck.js/dist/skins/snapgram.css';

import "../index.css";
import "./mainPage.css";

import { setImageSrc } from "../component/domHelpers.js";
import { getStoredGroupId, getStoredPhone, getChatId, getWebApp, getPlatform } from "../component/clientState.js";

import chevronRight from "../image/chevron-right.svg";
import gift from "../image/gift.svg";
import group from "../image/Group 50.svg";
import group1 from "../image/Group 51.svg";
import closeBtn1 from "../image/Union.svg";
import house1 from "../image/house-1.svg";
import chatDots from "../image/chat-dots-1.svg";
import mortarboard from "../image/mortarboard-white.svg";
import feadbackArrow from "../image/chevron-right-white.svg";
import { isMobile } from "../component/checkFullscreen.js";


[
  ["chevronRight", chevronRight],
  ["gift", gift],
  ["group", group],
  ["group1", group1],
  ["closeBtn1", closeBtn1],
  ["houseIcon", house1],
  ["chatDots", chatDots],
  ["closeBtn2", closeBtn1],
  ["mortaTeacher", mortarboard],
  ["feadbackArrow", feadbackArrow],
].forEach(([id, src]) => setImageSrc(id, src));


const clientGroupId = getStoredGroupId();
// Для запросов расписания CRM ожидает идентификатор с пробелами (например "33 333"),
// поэтому дополнительно берём «сырое» значение из localStorage без удаления пробелов.
const clientGroupIdForSchedule = (() => {
  const raw = localStorage.getItem("clientGroupId");
  if (raw == null || raw === "n/a") return null;
  return raw;
})();
let clientPhone = getStoredPhone();

let clientYcId;
let clientObj;

let WebApp = getWebApp();
if (WebApp) {
  WebApp.expand?.();
  WebApp.BackButton?.hide?.();
  WebApp.lockOrientation?.();
  if (getPlatform() === "telegram") {
    WebApp.isClosingConfirmationEnabled = true;
    WebApp.ready?.();
    WebApp.disableVerticalSwipes?.();
  } else if (typeof WebApp.enableClosingConfirmation === "function") {
    WebApp.enableClosingConfirmation();
  }
}


// WebApp.requestFullscreen();

// import "../component/checkFullscreen.js";


let chatId = getChatId();
//let chatId = "456072370";
const scheduleMoreButton = document.getElementById("scheduleMoreButton");
let AllSсheduleItem = "";
const goToPayPage = document.getElementById("payLoad");
const innerLesson = document.querySelector(".scheduleBody");
const todaySchedule = document.getElementById("todaySchedule");

goToPayPage.addEventListener("click", () => {
  window.location.href = "/pay";
});

if (clientGroupIdForSchedule) {
  safeFetch("/nextlessons", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ clientGroupId: clientGroupIdForSchedule }),
  })
    .then((res) => res.json())
    .then((data) => {
      displayLesson(data);
    })
    .catch((err) => {
      console.error(err);
    });

    safeFetch("/prevlessons", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ clientGroupId: clientGroupIdForSchedule }),
  })
    .then((res) => res.json())
    .then((data) => {
      displayNeedFeedback(data[0]);

    })
    .catch((err) => {
      console.error(err);
    });
}

const displayNeedFeedback = (data) => {
  const needFeedbackBlock = document.getElementById("linkToFeedback");
  if (data.client_feedback == null) {
    needFeedbackBlock.href = `/schedule?resource_id=${data.resource_id}`;
    needFeedbackBlock.classList.remove("classHide");
  }
}

let todayDate = new Date();

const displayLesson = (lesson) => {
  if (lesson.length > 0) {
    let flag = true;
    lesson.forEach(
      ({ lesson_name, lesson_date, teacher, lesson_date_for_js }, index) => {
        const match = lesson_date_for_js.match(/-?\d+(\.\d+)?/g);
        let lessonDay = parseInt(match[2]);
        let lessonMount = parseInt(match[1]);

        if (
          lessonDay == todayDate.getDate() &&
          lessonMount == todayDate.getMonth()
        ) {
          innerLesson.innerHTML += `
    <div class="scheduleItem">
      <div class="scheduleAbout">
        <h2 class="scheduleDate">
         ${lesson_date}
        </h2>
        <p class="sixe">${teacher}</p>
        <p class="sixe">${lesson_name}</p>
      </div>
    </div>`;
          flag = false;
        }
        if (lessonDay != todayDate.getDate() && flag) {
          todaySchedule.innerText = "На сегодня нет занятий";
          innerLesson.innerHTML = `
          <div class="scheduleItem">
            <div class="scheduleAbout">
              <h2 class="scheduleDate">
               Перейдите в расписание
              </h2>
            </div>
          </div>`;
        }
      },
    );
  } else {
    innerLesson.innerHTML += `
    <div class="scheduleItem">
      <div class="scheduleAbout">
        <h2 class="scheduleDate">
         Нет занятий в расписании
        </h2>
      </div>
    </div>`;
  }
  AllSсheduleItem = document.querySelectorAll(".scheduleItem");

  for (let i = 0; i < AllSсheduleItem.length; i++) {
    AllSсheduleItem[i].addEventListener("click", goToSchedule);
  }
};

safeFetch("/materials")
  .then((res) => res.json())
  .then((data) => {
    displayPopUp(data);
    displayMaterial(data);
  });

const popUp = document.getElementById("referrer");
const nameMaterialPopUp = document.getElementById("nameMaterialPopUp");
const descriptionPopUp = document.getElementById("descriptionPopUp");
const zero = document.getElementById("zero");

const innerPopUp = document.querySelector(".material");
const downLoad = document.getElementById("downLoad");

const takeBody = document.getElementsByTagName("body")[0];

const buttonName = document.getElementById("nameButtonPop");


buttonName.addEventListener("click", () => {
  const nameMaterial = document.getElementById("nameMaterialPopUp").innerText;
  const getUrl = `/itemsMetrika?location=main_materials&object=open-site&material_name=${nameMaterial}`;
  safeFetch(getUrl)
})

const displayMaterial = (data) => {
  const test = document.querySelectorAll(".openPopUp");
  for (let i = 0; i < test.length; i++) {
    test[i].addEventListener("click", () => {
      if (WebApp?.isFullscreen && isMobile()) {
        document.querySelector('.bPopupContent').style.paddingTop = '100px';
      }

      downLoad.setAttribute("href", data[i].url);
      takeBody.classList.add("removeScrolling");
      popUp.style.display = "flex";
      nameMaterialPopUp.innerHTML = data[i].name;
      descriptionPopUp.innerHTML = data[i].about;
      zero.style.backgroundImage = `url(${data[i].src})`;
      if (data[i].button == null) {
        buttonName.style.display = "none";
      } else {
        buttonName.style.display = "inline-block";
      }
      buttonName.innerHTML = data[i].button;
      const getUrl = `/itemsMetrika?location=main_materials&object=open-popup&material_name=${data[i].name}`;
      safeFetch(getUrl)
    });
  }
};

const displayPopUp = (data) => {
  data.forEach(({ name, src }, index) => {
    innerPopUp.innerHTML += `
        <div class="openPopUp" value="0">
            <div class="imgDiv" style="background-image: url(${src})"></div>
      
            <p class="labelFromImg">${name}</p>
        </div>`;
  });
};

popUp.addEventListener("click", (e) => {
  if (e.target.id === "referrer") {
    takeBody.classList.remove("removeScrolling");
    popUp.style.display = "none";
  }
});

const closePopUpButton = document.querySelector(".close-container-btn");

closePopUpButton.addEventListener("click", () => {
  takeBody.classList.remove("removeScrolling");
  popUp.style.display = "none";
  if (WebApp?.isFullscreen && isMobile()) {
    document.querySelector('.bPopupContent').style.paddingTop = 0;
  }

});

const goToSchedule = () => {
  window.location.href = "/schedule/";
};

scheduleMoreButton.addEventListener("click", goToSchedule);

const innerSlideBar = document.querySelector(".owerFlowWindod");

const regButton = document.getElementById("regis");
let flagRegis = false;

let allRefBanners = "";


const checkReferal = () => {
  safeFetch("/refProg", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ chatId: chatId }),
  })
    .then((res) => res.json())
    .then((data) => {
      clientObj = data;
      clientObj.type = "noAuth";
      if (data.status) {
        for (let i = 0; i < allRefBanners.length; i++) {
          if (data.refferal_program == "None") {
            allRefBanners[i].classList.forEach((value) => {
              if (value === "user") {
                allRefBanners[i].style.display = "flex";
              }
            })
          } else {
            allRefBanners[i].style.display = "flex";
            if (data.client_id === null) {
              document.querySelector(".btn").classList.add("classHide");
              regButton.classList.remove("classHide");
              document.getElementById("authText").innerText = 'Зарегистрируйтесь в личном кабинете CareMyBaby';
            }
          }
        }
      }


    })
    .catch((err) => {
      console.error(err);
    });
}


function getApiImport(yclientId) {

  safeFetch("/import", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      yclientId: yclientId,
    }),
  })
    .then((res) => res.json())
    .then((data) => {
    })
    .catch((err) => {
      console.error(err);
    });
}

const checkFirstLesson = () => {
  safeFetch("/client", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      clientPhone: clientPhone,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      getStory();
      if (data.length > 0) {
        localStorage.setItem(
          "_yc_id",
          data[0].client_yc_id,
        );

        clientObj = data;
        clientObj.type = "auth";

        clientYcId = data[0].client_yc_id;
        if (data[0].deposit_id === null) {
          getApiImport(data[0].client_yc_id);
        }

        // if (localStorage.getItem("avatar") === null) {
        getAvatar(data[0].client_yc_id);
        // }

        if (data[0].client_paid_multivalute === 0) {
          checkReferal();
        } else {
          for (let i = 0; i < allRefBanners.length; i++) {
            allRefBanners[i].classList.forEach((value) => {
              if (value === "user") {
                allRefBanners[i].style.display = "flex";
              }
            })
          }
        }
      } else {
        flagRegis = true;
        checkReferal();
      }

    })
    .catch((err) => {
      console.error(err);
    });
};


function getAvatar(clientYcId) {
  safeFetch("/getAvatar", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      clientYcId: clientYcId,
    })
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        if (localStorage.getItem("avatar") !== `url(${data.url})`) {
          localStorage.setItem("avatar", `url(${data.url})`);
          // location.reload();
        }
      }
    })
    .catch((err) => {
      console.error(err);
    })
}


safeFetch("/banners")
  .then((res) => res.json())
  .then((data) => {
    displayBanners(data);
    checkFirstLesson();
    sendNotify();
  })
  .catch((err) => {
    console.error(err);
  });

const displayBanners = (data) => {
  // let innerP = "";
  data.forEach(({ name, src, about, segment, button }, index) => {
    let innerP = "";
    let title = "";
    let innerButton = "";


    if (about === null) {
      innerP = "";
    } else {
      innerP = `<p class="tooltip">${about}</p>`;
    }
    // let innerButton = "";
    if (name != null) {
      title = name;
    }
    if (button !== undefined) {
      if (button.url == "send_notify") {
        innerButton = `<button class="smallBtn sendForm" data-name="${name}" data-title="${about}">${button.name}</button>`
      } else {
        innerButton = `<a href=${button.url} target=${button.target}><button class="smallBtn">${button.name}</button></a>`;
      }
    }
    innerSlideBar.innerHTML += `
    <div class="slide ${segment.join(" ")}" style="background-image: url('${src}');">
    <h2 class="h3Ower">${title}</h2>
    ${innerP}
    ${innerButton}
  </div>`;
  });
  allRefBanners = document.querySelectorAll(".ref");
};

function sendNotify() {
  const allSlideBtn = document.querySelectorAll(".sendForm");
  const displayNotify = document.getElementById("notify");
  const closeNotify = document.getElementById("closeBtn2");
  const confirmSendBtn = document.getElementById("confirmSend");
  const cancelSendBtn = document.getElementById("cancelSend");
  let nameNotify = "";
  let titleNotify = "";
  for (let i = 0; i < allSlideBtn.length; i++) {
    allSlideBtn[i].addEventListener("click", () => {
      nameNotify = allSlideBtn[i].getAttribute("data-name");
      titleNotify = allSlideBtn[i].getAttribute("data-title");
      displayNotify.style.display = "flex";
    })
  }

  confirmSendBtn.addEventListener("click", () => {
    safeFetch("./sendNotify", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ client: clientObj, nameNotify: nameNotify, type: clientObj.type, title: titleNotify })
    })
      .then((responce) => responce.text())
      .then((data) => {
        if (data == "true") {
          showAlert("Мы скоро Вам напишем!");
        } else {
          showAlert("Возникла ошибка, попробуйте позднее!");
        }

        displayNotify.style.display = "none";
      })
  })

  displayNotify.addEventListener("click", (e) => {
    if (e.target.id == "notify") {
      displayNotify.style.display = "none";
    }
  })
  cancelSendBtn.addEventListener("click", () => {
    displayNotify.style.display = "none";
  })
  closeNotify.addEventListener("click", () => {
    displayNotify.style.display = "none";
  })
}




var timestamp = function () {
  var timeIndex = 0;
  var shifts = [35, 60, 60 * 3, 60 * 60 * 2, 60 * 60 * 25, 60 * 60 * 24 * 4, 60 * 60 * 24 * 10];

  var now = new Date();
  var shift = shifts[timeIndex++] || 0;
  var date = new Date(now - shift * 1000);

  return date.getTime() / 1000;
};

const options = {
  skin: 'Snapgram',
  backNative: true,
  backButton: false,
  previousTap: true,
  avatars: true,
  list: false,
  autoFullScreen: false,
  cubeEffect: true,
  paginationArrows: true,
  localStorage: true,
};

const STORIES_CACHE_KEY = "cmb_stories_cache_v1";
const element = document.getElementById("stories");
let storiesInstance = null;

const saveStoriesCache = (data) => {
  try {
    localStorage.setItem(STORIES_CACHE_KEY, JSON.stringify({ data, ts: Date.now() }));
  } catch (_) {
    /* ignore quota errors */
  }
};

const loadStoriesCache = () => {
  try {
    const raw = localStorage.getItem(STORIES_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed.data)) return null;
    return parsed.data;
  } catch (_) {
    return null;
  }
};

const ensureStoriesInstance = () => {
  if (!storiesInstance) {
    storiesInstance = Zuck(element, options);
    return storiesInstance;
  }
  element.innerHTML = "";
  storiesInstance = Zuck(element, options);
  return storiesInstance;
};

const attachStoryMetrics = () => {
  const takeAllStory = document.querySelectorAll(".story");
  for (let i = 0; i < takeAllStory.length; i++) {
    takeAllStory[i].addEventListener("click", () => {
      const storyId = takeAllStory[i].getAttribute("data-id");
      const getUrl = `/itemsMetrika?location=stories&object=open&stories_id=${storyId}&client_id=${clientYcId}`
      safeFetch(getUrl);
    });
  }
};

const renderStories = (data) => {
  const stories = ensureStoriesInstance();
  data.forEach((value) => {
    const testStoryItem = [];

    if (value.data.length > 0) {
      for (let i = 0; i < value.data.length; i++) {
        let length = 0;
        if (value.data[i].type === "photo") {
          length = 6;
        }
        if (value.data[i].button.url) {
          testStoryItem.push({ id: i, type: value.data[i].type, redirect: value.data[i].button.redirect, link: value.data[i].button.url, linkText: value.data[i].button.title, src: value.data[i].item, preview: value.data[i].item, time: timestamp(), length: length })
        } else {
          testStoryItem.push({ id: i, type: value.data[i].type, src: value.data[i].item, preview: value.data[i].item, time: timestamp(), length: length })
        }
      }
    }
    const story = {
      id: `number-${value.id}`,
      clientId: clientYcId,
      items: testStoryItem,
      photo: value.preview,
      time: timestamp(),
    }
    stories.add(story);
  });
  attachStoryMetrics();
};

function getStory() {
  const cachedStories = loadStoriesCache();
  if (cachedStories) {
    renderStories(cachedStories);
  }

  safeFetch("/getStory")
    .then((response) => response.json())
    .then((data) => {
      saveStoriesCache(data);
      renderStories(data);
    })
    .catch((err) => {
      console.error(err);
    });
}

const anyFeadbackBnt = document.getElementById("anyFeadback");

anyFeadbackBnt.addEventListener("click", () => {
  const getUrl = `/itemsMetrika?location=main-feedback&object=open_main_feedback&source=main-page&client_id=${clientYcId}`
  safeFetch(getUrl);
})

const goToCatalog = document.getElementById("pickTeacherPage");

goToCatalog.addEventListener("click", () => {
  window.location.href = "/teacher";
  WebApp?.BackButton.show?.();
})